import { i18n } from "translate/i18n"

export const title = i18n.t("titles.editPlan.title")
export const subtitle = i18n.t("titles.editPlan.subtitle")
export const formChecklistTitle = i18n.t("messages.editPlan.formChecklistTitle")
